import * as $ from 'jquery';
import { isBreakpoint } from '@fnv-core/dom';

function initContentAccordionOpeningViaUrlController() {
  if ($(".content__accordion").length > 0 || 
      $(".container  featured-faq").length > 0) {
    let accordionAnchorId = location.hash;
    // replace react root routing (could be automatically added depending on other widgets)
    if(accordionAnchorId.indexOf("#/") != -1) {
      accordionAnchorId = accordionAnchorId.replace("#/", "#");
    }
    // check if an id has been provided and its not a react route (#/mijn-fnv/lid)
    if (accordionAnchorId != "" && accordionAnchorId != "#" && (accordionAnchorId.indexOf("/") == -1)) {
      const accordionAnchorElement = $(accordionAnchorId + " + .collapse");
      if (accordionAnchorElement.length > 0) {
        accordionAnchorElement.collapse('show');
        let extraSpace = 0;
        if (isBreakpoint("xs") || isBreakpoint("sm") || isBreakpoint("md")) {
          extraSpace = $(".main-navbar").height();
        }
        setTimeout(function () {
          $('html, body').animate({
            scrollTop: ($(accordionAnchorId).offset().top - extraSpace) + 'px'
          });
        }, 500);
      }
    }
  } else {
    const anchorId = location.hash;
    if (anchorId != "" && anchorId != "#" && (anchorId.indexOf("#/") == -1) && (anchorId.indexOf("#mijn-fnv") == -1)) {
      const anchorElement = $(anchorId);
      if (anchorElement.length > 0) {        
        let extraSpace = 0;
        if (isBreakpoint("xs") || isBreakpoint("sm") || isBreakpoint("md")) {
          extraSpace = $(".main-navbar").height();
        }
        $('html, body').animate({
          scrollTop: ($(anchorElement).offset().top - extraSpace) + 'px'
        });
      }
    }
  }
}

export { initContentAccordionOpeningViaUrlController };